import React, { useState, useEffect } from "react";
import "./VideoPlayer.scss";
import "./Adaptations.scss";
import Loader from "../loader-spinner/Loader"

export default function VideoPlayer({ video_links = [] }) {
  
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (video_links.length > 0 || video_links.length === 0) {
      setTimeout(() => setIsLoading(false), 500);
    }
  }, [video_links]);

  return (
    <div className="video-player-wrapper">
      {isLoading && <Loader isVisible={true} />}

      {!isLoading && video_links.length > 0 ? (
        video_links.map((link, index) => (
          <iframe
            key={index}
            src={link}
            title={`YouTube video player ${index + 1}`}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
        ))
      ) : (
        !isLoading && <p className="error">No videos available</p>
      )}
    </div>
  );
}
